import { useRouter } from 'next/router';

export const useQuery = (queryParam = null) => {
    const router = useRouter();
    const path = router.asPath;
    const queryString = path.substring(path.indexOf('?') + 1).split('&');
    const params = {};
    let pair;
    const d = decodeURIComponent;

    for (let i = queryString.length - 1; i >= 0; i--) {
        pair = queryString[i].split('=');

        const key = d(pair[0]);
        const val = d(pair[1]) || '';

        if (params.hasOwnProperty(key)) {
            if (Array.isArray(params[key])) {
                params[key].unshift(val);
            } else {
                params[key] = [params[key]];
                params[key].unshift(val);
            }
        } else {
            params[key] = val;
        }
    }

    if (queryParam) {
        return params[queryParam];
    }

    return params;
};
